<template>
  <Modal
    open
    @close="handleCancelButtonClick"
    :hideScrollbar="true"
    class=" [&_.modal-position]:!items-start [&_.modal-position]:!px-6 [&_.modal-position]:!pb-6 [&_.modal-position]:!pt-24"
    :roundedOnMobile="true"
  >
    <div v-if="!isRegistered" class="flex flex-col items-center gap-8 p-9">
      <!-- Header -->

      <div class="flex w-full flex-col items-center gap-4">
        <span class="text-2xl font-medium text-zinc-800 sm:text-3xl"
          >{{__('Quick Register')}}</span
        >
        <span
          class="text-center text-base font-normal text-zinc-800 sm:text-lg"
        >
          {{__('Upon registration for the event, your account will be automatically created.')}}</span
        >
      </div>

      <form class="flex w-full flex-col gap-4" @submit.prevent="handleSubmit">
        <InputText
          id="first_name"
          v-model:value="values.first_name"
          v-model:errors="errors.first_name"
          :label="__('First name')"
          :placeholder="__('First name')"
          required
        />

        <InputText
          id="last_name"
          v-model:value="values.last_name"
          v-model:errors="errors.last_name"
          :label="__('Last name')"
          :placeholder="__('Last name')"
          required
        />

        <InputEmail
          id="email"
          v-model:value="values.email"
          v-model:errors="errors.email"
          :label="__('Email')"
          :placeholder="__('Your email')"
          required
        />

        <InputPassword
          id="password"
          v-model:value="values.password"
          v-model:errors="errors.password"
          :label="__('Password')"
          :placeholder="__('Choose your password')"
          required
        />
        <div class="flex flex-col gap-3">
          <div class="flex flex-row gap-2">
            <div class="flex items-center gap-2">
              <Icon
                :class="[
                  passwordRules.min === null
                    ? 'text-gray-400'
                    : passwordRules.min
                      ? 'text-green-600'
                      : 'text-red-600'
                ]"
                :name="
                  passwordRules.min === null || passwordRules.min
                    ? 'done'
                    : 'close'
                "
              />
              <span class="text-xs text-zinc-600">
                {{ __('min 8 characters') }}
              </span>
            </div>
            <div class="flex items-center gap-2">
              <Icon
                :class="[
                  passwordRules.min === null
                    ? 'text-gray-400'
                    : passwordRules.upper
                      ? 'text-green-600'
                      : 'text-red-600'
                ]"
                :name="
                  passwordRules.min === null || passwordRules.upper
                    ? 'done'
                    : 'close'
                "
              />
              <span class="text-xs text-zinc-600">
                {{ __('one uppercase letter') }}
              </span>
            </div>
            <div class="flex items-center gap-2">
              <Icon
                :class="[
                  passwordRules.min === null
                    ? 'text-gray-400'
                    : passwordRules.lower
                      ? 'text-green-600'
                      : 'text-red-600'
                ]"
                :name="
                  passwordRules.min === null || passwordRules.lower
                    ? 'done'
                    : 'close'
                "
              />
              <span class="text-xs text-zinc-600">
                {{ __('one lowercase letter') }}
              </span>
            </div>
          </div>
          <div class="flex flex-row gap-2">
            <div class="flex items-center gap-2">
              <Icon
                :class="[
                  passwordRules.min === null
                    ? 'text-gray-400'
                    : passwordRules.number
                      ? 'text-green-600'
                      : 'text-red-600'
                ]"
                :name="
                  passwordRules.min === null || passwordRules.number
                    ? 'done'
                    : 'close'
                "
              />
              <span class="text-xs text-zinc-600">
                {{ __('one number') }}
              </span>
            </div>
            <div class="flex items-center gap-2">
              <Icon
                :class="[
                  passwordRules.min === null
                    ? 'text-gray-400'
                    : passwordRules.special
                      ? 'text-green-600'
                      : 'text-red-600'
                ]"
                :name="
                  passwordRules.min === null || passwordRules.special
                    ? 'done'
                    : 'close'
                "
              />
              <span class="text-xs text-zinc-600">
                {{ __('one special character (@, #, $)') }}
              </span>
            </div>
          </div>
        </div>
        <InputPassword
          id="password_confirmation"
          v-model:value="values.password_confirmation"
          v-model:errors="errors.password_confirmation"
          :label="__('Confirm your password')"
          :placeholder="__('Rewrite your password')"
          required
          class="md:col-start-2"
        />

        <div class="pt-4 text-sm">

          <div class="space-y-2 ">
                      <InputCheckbox
                        id="recruit"
                        v-model:value="values.recruit"
                        v-model:errors="errors.recruit"
                        :label="__('I agree to the')"
                        class="mb-6"
                      >
                        <template #default>
                          <a :href="props.terms" target="_blank" class="text-black underline">{{
                            __('terms and conditions')
                          }}</a>
                          {{ __(' and the ') }}
                          <a :href="props.privacy" target="_blank" class="text-black underline">{{
                            __('privacy policy')
                          }}</a
                          >.
                        </template>
                      </InputCheckbox>

                      <InputCheckbox
                          id="marketing"
                          v-model:value="values.marketing"
                          v-model:errors="errors.marketing"
                          :label="__('I would like to receive updates about career opportunities that match my skills.')"
                          class="mb-6"
                      />


                    </div>
        
        </div>

        <div class="pt-4 text-center">
          <p class="text-sm">
            {{ __('Already have an account?') }}
            <a
              @click="redirectTo('login')"
              class="cursor-pointer font-medium text-primary"
              >{{ __('Sign In') }}</a
            >
          </p>
        </div>

        <div
          class="flex flex-col items-center gap-2 md:flex-row-reverse md:justify-center"
        >
          <Button
            class="flex items-center justify-center gap-1.5"
            :type="isLoading ? 'button' : 'submit'"
            :disabled="isLoading"
            style="width: 10rem !important"
          >
            <Icon
              v-if="isLoading"
              class="animate-spin text-lg"
              name="progress_activity"
            />
            <span>{{ __('Register') }}</span>
          </Button>
        </div>
      </form>
    </div>

    <div
      v-else
      class="m-10 flex flex-col items-center gap-4 text-center sm:rounded-lg"
    >
      <img
        src="/images/front/verify-account.png"
        class="h-44 w-44"
        alt="Jobful"
      />

      <h2 class="mt-4 text-2xl font-bold text-gray-900">
        {{ __('Please verify your email to complete your registration.') }}
      </h2>

      <p class="text-sm text-gray-600">
        {{ __('The confirmation code was sent to your email') }}
        <strong>{{ maskedEmail(successMessage.email) }}</strong>
      </p>
    </div>
  </Modal>
</template>

<script setup>
  import { computed, ref, watch } from 'vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';

  import { InputEmail } from '../../../../../../../../components/form/input-email';
  import { InputPassword } from '../../../../../../../../components/form/input-password';
  import { InputText } from '@/components/form/input-text';
  import Modal from '../../../../../../../../components/block/modal/modal.vue';
  import { InputCheckbox } from '../../../../../../../../components/form/input-checkbox';

  const props = defineProps({
    event: {
      type: Object,
      required: true
    }
  });

  const values = ref({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password_confirmation: '',
    recruit: false,
    marketing: false
  });

  const errors = ref({
    first_name: [],
    last_name: [],
    email: [],
    password: [],
    password_confirmation: [],
    recruit: []
  });

  const routes = {
    companyRegister: 'front.auth.company.register',
    candidateRegister: 'front.auth.register',
    login: 'login.user'
  };
  const redirectTo = (routeName) => {
    window.location.href = route(routes[routeName]);
  };

  const passwordRules = ref({
    min: null,
    upper: null,
    lower: null,
    number: null,
    special: null
  });
  const toast = useToast();
  const isLoading = ref(false);
  const successMessage = ref(null);
  const isRegistered = ref(false);
  watch(
    () => values.value.password,
    (newPassword) => {
      passwordRules.value.min =
        newPassword.length === 0 ? null : newPassword.length >= 8;
      passwordRules.value.upper =
        newPassword.length === 0 ? null : /[A-Z]/.test(newPassword);
      passwordRules.value.lower =
        newPassword.length === 0 ? null : /[a-z]/.test(newPassword);
      passwordRules.value.number =
        newPassword.length === 0 ? null : /\d/.test(newPassword);
      passwordRules.value.special =
        newPassword.length === 0 ? null : /[@#$%^&*]/.test(newPassword);
    }
  );

  const emits = defineEmits(['cancel']);

  function handleCancelButtonClick() {
    emits('cancel');
  }

  async function handleSubmit() {
    const requiredFieldKeys = [
      'first_name',
      'last_name',
      'email',
      'password',
      'password_confirmation',
      'recruit'
    ];
    let firstElement;

    requiredFieldKeys.forEach((key) => {
      if (!values.value[key]) {
        errors.value[key] = [__('This field is required')];

        const element = document.getElementById(key);

        if (element && !firstElement) {
          firstElement = element;
        }
      }
    });

    if (!values.value.recruit) {
      errors.value.recruit = [
        __('You must agree to the terms and conditions.')
      ];
    }

    if (values.value.password !== values.value.password_confirmation) {
      errors.value.password_confirmation = [
        __('Your new password must match the confirmation password')
      ];
    }

    if (Object.values(errors.value).some((error) => error.length)) {
      if (firstElement) {
        firstElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    isLoading.value = true;
   
    successMessage.value = null;
    try {
      const tempValues = {
        ...values.value,
        event_slug: props.event.details.slug,
        event_name: props.event.details.name,
        event_date: props.event.details.start_date_time
      };

      const apiUrl = '/register';
      const response = await axios.post(apiUrl, tempValues);

      if (response?.data?.status === 'success') {
        isRegistered.value = true;
        successMessage.value = { email: values.value.email };
      } else {
        toast.error(__('An unexpected error has occurred. Please try again.'));
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        errors.value = error.response.data.errors;
      } else if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(
          __('An unexpected error has occurred. Please try again later.')
        );
      }
    }

    isLoading.value = false;
  }

  const maskedEmail = (email) => {
    if (!email) return '';
    const [name, domain] = email.split('@');
    return `${name[0]}****${name.slice(-1)}@${domain}`;
  };
</script>
